import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getReleaseTypeSpeaker } from "src/apis/VersionRelease/typeSpeaker.api";
import Controls from "src/components/form/controls/Controls";

const ReleaseSpeakerVersionPanelOptional = ({
  releaseTypeSpeakerId,
  environmentId,
  envOption,
  onChangeEnvironment,
  onChangeTypeSpeaker,
}) => {
  const [releaseTypeSpeakers, setReleaseTypeSpeakers] = useState([]);

  useEffect(() => {
    getReleaseTypeSpeaker({}, (result) => {
      setReleaseTypeSpeakers([...result.list]);
    });
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <Controls.Select
        name="releaseTypeSpeakerId"
        label="Type Speaker"
        value={releaseTypeSpeakerId}
        onChange={(e) => onChangeTypeSpeaker(e.target.value)}
        options={releaseTypeSpeakers}
        style={{ width: "200px" }}
      />
      <Controls.Select
        name="environmentId"
        label="Environment"
        value={environmentId}
        onChange={(e) => onChangeEnvironment(e.target.value)}
        options={envOption}
        style={{ width: "200px", marginLeft: "10px" }}
      />
    </div>
  );
};

export default ReleaseSpeakerVersionPanelOptional;
